import * as React from 'react';
import { 
  Typography, 
  Box, 
  Card,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { Link as RouterLink } from 'react-router-dom';

// App-like styled components
const MenuContainer = styled(Box)(({ theme }) => ({
  marginBottom: '16px',
  width: '100%',
  maxWidth: '100%',
  overflow: 'hidden',
  background: 'linear-gradient(135deg, #0B0E11 0%, #161A1E 100%)',
  padding: '16px 0',
  [theme.breakpoints.down('md')]: {
    background: 'transparent',
    padding: '0'
  }
}));

const ScrollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '12px',
  overflowX: 'auto',
  overflowY: 'hidden',
  padding: '8px 16px 12px 16px',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  maxWidth: '100%',
  width: '100%',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  '&::after': {
    content: '""',
    minWidth: '8px'
  },
  [theme.breakpoints.down('md')]: {
    padding: '8px 4px 12px 4px'
  },
  [theme.breakpoints.up('lg')]: {
    justifyContent: 'space-between',
    gap: '16px',
    padding: '8px 24px 12px 24px',
    overflowX: 'visible'
  },
  [theme.breakpoints.up('xl')]: {
    gap: '20px',
    padding: '8px 32px 12px 32px'
  }
}));

const QuickActionItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  minWidth: '75px',
  flexShrink: 0,
  cursor: 'pointer',
  textDecoration: 'none',
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-2px)',
    '& .action-icon': {
      borderColor: '#F7931A',
      background: 'linear-gradient(135deg, rgba(247, 147, 26, 0.2) 0%, rgba(247, 147, 26, 0.08) 100%)',
      transform: 'scale(1.05)'
    },
    '& .action-title': {
      color: '#F7931A'
    }
  },
  [theme.breakpoints.up('lg')]: {
    minWidth: 'auto',
    flex: '1 1 0',
    maxWidth: '120px',
    flexShrink: 1
  },
  [theme.breakpoints.up('xl')]: {
    maxWidth: '140px'
  }
}));

const ActionIcon = styled(Box)(({ theme }) => ({
  width: '52px',
  height: '52px',
  borderRadius: '16px',
  background: 'linear-gradient(135deg, #161A1E 0%, #1E2328 100%)',
  border: '1px solid #2B3139',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '8px',
  transition: 'all 0.3s ease',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
  '& img': {
    width: '26px',
    height: '26px',
    objectFit: 'contain'
  },
  [theme.breakpoints.up('lg')]: {
    width: '60px',
    height: '60px',
    borderRadius: '18px',
    marginBottom: '10px',
    '& img': {
      width: '30px',
      height: '30px'
    }
  },
  [theme.breakpoints.up('xl')]: {
    width: '68px',
    height: '68px',
    borderRadius: '20px',
    marginBottom: '12px',
    '& img': {
      width: '34px',
      height: '34px'
    }
  }
}));

const ActionTitle = styled(Typography)(({ theme }) => ({
  color: '#FFFFFF',
  fontSize: '10px',
  fontWeight: 600,
  textAlign: 'center',
  transition: 'color 0.3s ease',
  lineHeight: 1.2,
  width: '65px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  [theme.breakpoints.up('lg')]: {
    fontSize: '11px',
    width: 'auto',
    maxWidth: '100px'
  },
  [theme.breakpoints.up('xl')]: {
    fontSize: '12px',
    maxWidth: '120px'
  }
}));

const menuItems = [
  // {
  //   title: 'P2P Trading',
  //   icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068353/peer-to-peer_ekkqj5.png',
  //   path: '/p2p'
  // },
 
  {
    title: 'Deposits',
    icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068353/wallet_b7ymoh.png',
    path: '/account-wallet'
  },
  {
    title: 'Invest',
    icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738083863/candle_l9uey7.png',
                path: '/package/Investment Portfolios'
  },
  {
    title: 'Joint Investment',
    icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068352/analytics_tjm1c0.png',
    path: '/copy-plans'
  },
  {
    title: 'Assets',
    icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068347/wallet_1_vmr3li.png',
    path: '/assets'
  },
  // Swap menu item removed
  // {
  //   title: 'Swap',
  //   icon: 'https://res.cloudinary.com/dqi4rtyvh/image/upload/v1739863653/swap_vw5hqj.png',
  //   path: '/swap-coin'
  // },
  // {
  //   title: 'Web3',
  //   icon: 'https://res.cloudinary.com/dqi4rtyvh/image/upload/v1738590761/web3_ztvzkf.png',
  //   path: '/web3'
  // },
 
  
  {
    title: 'Referrals',
    icon: 'https://res.cloudinary.com/dmzqkpypw/image/upload/v1738068352/gift_mjan0v.png',
    path: '/referrals'
  }
];

export default function MobileMenu() {
  const scrollContainerRef = React.useRef(null);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  React.useEffect(() => {
    const container = scrollContainerRef.current;
    if (!container || isDesktop) return; // Disable auto-scroll on desktop

    let scrollDirection = 1; // 1 for right, -1 for left
    let isScrolling = false;

    const autoScroll = () => {
      if (isScrolling) return;
      
      isScrolling = true;
      const scrollAmount = 100;
      const maxScroll = container.scrollWidth - container.clientWidth;
      
      if (container.scrollLeft >= maxScroll) {
        scrollDirection = -1; // Start scrolling left
      } else if (container.scrollLeft <= 0) {
        scrollDirection = 1; // Start scrolling right
      }
      
      container.scrollBy({
        left: scrollAmount * scrollDirection,
        behavior: 'smooth'
      });
      
      setTimeout(() => {
        isScrolling = false;
      }, 1000);
    };

    const interval = setInterval(autoScroll, 3000); // Auto scroll every 3 seconds

    // Pause autoscroll on hover
    const handleMouseEnter = () => clearInterval(interval);
    const handleMouseLeave = () => {
      clearInterval(interval);
      setTimeout(() => {
        if (container) {
          const newInterval = setInterval(autoScroll, 3000);
          container.addEventListener('mouseenter', () => clearInterval(newInterval));
        }
      }, 1000);
    };

    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      clearInterval(interval);
      if (container) {
        container.removeEventListener('mouseenter', handleMouseEnter);
        container.removeEventListener('mouseleave', handleMouseLeave);
      }
    };
  }, [isDesktop]);

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      <MenuContainer>
        <ScrollContainer ref={scrollContainerRef}>
          {menuItems.map((item, index) => (
            <QuickActionItem 
              key={index}
              component={RouterLink} 
              to={item.path}
              sx={{ textDecoration: 'none' }}
            >
              <ActionIcon className="action-icon">
                <img src={item.icon} alt={item.title} />
              </ActionIcon>
              <ActionTitle className="action-title">{item.title}</ActionTitle>
            </QuickActionItem>
          ))}
        </ScrollContainer>
      </MenuContainer>
        </Box>
  );
}